import { Editor, Transforms, Node, Range, Path, NodeEntry } from 'slate'
import { Registry } from '@react-registry'
import React from 'react'
import { useSlate } from 'slate-react'

import { elementCategories } from '../../elementCategories'
import { TableAddRowAfterIcon } from '../../../utils/Icon'
import RTE_SHORTCUT from '../../../../../../../utils/common-rte-utils/shortcuts.constant'
import { createCell } from './createCell'
import { cellType, isCellSpanning } from './mergeCells'
import { getSpanningCell } from './helper'
import { incrementRowSpan } from './insertRowBefore'
import { uniqBy } from 'lodash'

export const insertRowAfter = (event, { editor }) => {
  const cellEntry = Editor.above(editor, {
    match: (n) => {
      return cellType.includes(n["type"])
    },
    mode: 'lowest'
  })

  const tableEntry = Editor.above(editor, {
    match: (n) => {
      return n["type"] === 'table'
    },
    mode: 'lowest'
  })

  if (!tableEntry || !cellEntry) return

  const rowEntry = Editor.above(editor, {
    match: (n) => {
      return n["type"] === 'tr'
    },
    mode: 'lowest'
  })

  const cellsInCurrentRow = rowEntry[0].children.map((cell, index) => {
    return [cell, [...rowEntry[1], index]] as NodeEntry<Node>
  })

  const cellsToIncrementRowSpanTo: NodeEntry<Node>[] = []

  const newRowChildren = []

  for (const [cell, path] of cellsInCurrentRow) {
    let isVoid = false
    let { rowSpan, colSpan } = cell?.['attrs'] ?? {}

    if (rowSpan && rowSpan > 1) {
      isVoid = true
      cellsToIncrementRowSpanTo.push([cell, path])
    }
    if (Editor.isVoid(editor, cell)) {

      const spanningCellEntry = getSpanningCell(editor, path)

      if (spanningCellEntry) {
        const [spanningCell, spanningCellPath] = spanningCellEntry
        const { hasRowSpan } = isCellSpanning(spanningCell)
        if (
          (hasRowSpan && spanningCellPath.at(-2) === path.at(-2)) ||
          spanningCellPath.at(-2) + spanningCell?.['attrs']?.rowSpan - 1 > path.at(-2)
        ) {
          cellsToIncrementRowSpanTo.push(spanningCellEntry)
          isVoid = true
        }
      }
    }

    let cellToInsert = createCell(cell['type'], isVoid)
    newRowChildren.push(cellToInsert)
  }

  for (const ne of uniqBy(cellsToIncrementRowSpanTo, (ne) => ne[1].join(','))) {
    incrementRowSpan(editor, ne)
  }

  Transforms.insertNodes(editor, {
    type: 'tr',
    attrs: {},
    children: newRowChildren
  } as Node, {
    at: Path.next(rowEntry[1])
  })

  Transforms.setNodes(
    editor,
    {
      attrs: {
        ...tableEntry[0]["attrs"],
        rows: tableEntry[0]["attrs"].rows + 1
      }
    } as Partial<Node>,
    { at: tableEntry[1] }
  )

}
const insertRowAfterButtonDisabler = ({ editor }) => {

  if (editor.selection && Range.isExpanded(editor.selection)) return true

  const [table] = Editor.nodes(editor, {
    match: (n) => {
      return n["type"] === 'table'
    },
    mode: 'lowest'
  })
  return !table
}
const InsertRowBottomButton = (props) => {
  const editor = useSlate()
  return (
    <React.Fragment>
      {props.children({
        handleMouseDown: insertRowAfter,
        isDisable: { func: insertRowAfterButtonDisabler, params: { editor } },
        additionalParams: { editor }
      })}
    </React.Fragment>
  )
}

const shortcutInsertRowAfter = (event, editor, format, registryObj) => {
  insertRowAfter(event, { editor })
}
Registry.register(
  {
    iconName: <TableAddRowAfterIcon />,
    IngressComponent: InsertRowBottomButton,
    category: elementCategories.TABLE_ACTION,
    toolbar: {
      inSlashToolbar: false
    },
    shortcut: { key: RTE_SHORTCUT.ADD_ROW_BELOW, callback: shortcutInsertRowAfter },
    canCustomize: false,
    title: 'Insert row below',
    isContentStackElement: true
  },
  {
    id: 'table-insert-row-bottom',
    registry: 'v2.element'
  }
)
